import React from "react";

const Footer = () => {
  return <div className="footer">&copy;Cryptoverse 2022</div>;
};

export default Footer;
